import { Route, Switch } from "react-router-dom";
import BulkUnsubscribe from "./views/BulkUnsubscribe";
import ThankYou from "./views/ThankYou";
import MultiselectUnsubscribe from "./views/MultiselectUnsubscribe";
import NotFound from "./views/NotFound";
import Business from "./views/Business";
import ErrorHandler from "./components/ErrorHandler";
import CommunicationsHub from "./views/CommunicationsHub";
import QueryParameters from "./api/QueryParameters";

const COMMUNICATIONS_HUB: string = "ch";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/v0">
        <Business />
      </Route>
      <Route exact path="/v1">
        <ErrorHandler>
          <MultiselectUnsubscribe />
        </ErrorHandler>
      </Route>
      <Route
        path="/v2"
        render={() => {
          const queryParams = new QueryParameters();
          if (queryParams.getScr() === COMMUNICATIONS_HUB) {
            return (
              <ErrorHandler>
                <CommunicationsHub />
              </ErrorHandler>
            );
          } else
            return (
              <ErrorHandler>
                <BulkUnsubscribe />
              </ErrorHandler>
            );
        }}
      ></Route>
      <Route exact path="/thankyou">
        <ThankYou />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}
